import BaseObjectStore from './base/base-object-store';


class InboxStore extends BaseObjectStore {
    constructor () {
        super({
            isUnreadConvosCountSyncing: false,
            unreadConvosCount: 0,
        })
    }

    setUnreadConvosCount (count) {
        this.set({
            unreadConvosCount: count,
        })
    }

    startUnreadConvosCountSync () {
        this.set({
            isUnreadConvosCountSyncing: true,
        })
    }

    finishUnreadConvosCountSync () {
        this.set({
            isUnreadConvosCountSyncing: false,
        })
    }
    clear () {
        this.set({
            isUnreadConvosCountSyncing: false,
            unreadConvosCount: 0,
        })
    }
}

const inboxStore = new InboxStore()
export default inboxStore